
import { AuditInstructionFileModel, FileModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import Page from '@/Page.vue';
import axios from 'axios';
import { getAccessToken } from 'axios-jwt';
import { Component, VModel, Watch } from 'vue-property-decorator';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

@Component({
    components: { VuePdfEmbed },
})
export default class InstructionFilePreview extends Page {
    blobUrl = '';
    zoomed = false;
    loading = false;
    currentFileIndex = 0;

    @VModel() files!: AuditInstructionFileModel[];
    protected file: FileModel | null = null;

    protected get canPrev(): boolean {
        return this.currentFileIndex > 0;
    }

    protected get canNext(): boolean {
        return this.files.length > this.currentFileIndex + 1;
    }

    get isImage(): boolean {
        const imageTypes = ['image/jpeg', 'image/png', 'image/svg+xml', 'image/heic'];
        return imageTypes.any((n) => n == this.file?.contentType);
    }

    get isPdf(): boolean {
        const pdfTypes = ['application/pdf'];
        return pdfTypes.any((n) => n == this.file?.contentType);
    }

    mounted() {
        if (this.files.length > 0) {
            this.file = this.files[0].file!;
            this.getFile(this.file);
        }
    }

    getFile(file: FileModel) {
        const targetFile = file;
        if (targetFile) {
            this.loading = true;
            const tenantId = authStore.useGetter(AuthGetter.GetTenant);
            const token = getAccessToken();
            axios({
                url: (window as any).ApiService.baseUrl + '/api/files/' + targetFile.id! + '/download',
                method: 'GET',
                responseType: 'blob', // important,
                headers: {
                    TenantId: tenantId,
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((response) => {
                    this.loading = false;
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: file.contentType! }));
                    this.blobUrl = url;
                })
                .catch((e: any) => {
                    this.loading = false;
                    return '';
                });
        }
    }

    protected prev() {
        this.currentFileIndex--;
        this.file = this.files[this.currentFileIndex];
        this.getFile(this.file);
    }

    protected next() {
        this.currentFileIndex++;
        this.file = this.files[this.currentFileIndex];
        this.getFile(this.file);
    }
}
